import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class UserWithRolesAndPermissionsGrantedResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            'object': {
                'delivery_site_user_roles': [{
                    'delivery_site': {
                        'address': 'AV. DE LOS TRIGALES 1200',
                        'city': 'VILLA HARINA',
                        'code': '00',
                        'customer': {
                            'business_name': 'PANADERIA EL TRIGO DORADO SA',
                            'code': '000314',
                            'fantasy_name': 'EL TRIGO DORADO',
                            'taxpayer_identification_number': '30456789012'
                        },
                        'name': 'OFICINA CENTRAL'
                    },
                    'role': 'FRONTOFFICE_ORDERS_ADMIN'
                }, {
                    'delivery_site': {
                        'address': 'AV. DE LOS TRIGALES 1200',
                        'city': 'VILLA HARINA',
                        'code': '00',
                        'customer': {
                            'business_name': 'PANADERIA EL TRIGO DORADO SA',
                            'code': '000314',
                            'fantasy_name': 'EL TRIGO DORADO',
                            'taxpayer_identification_number': '30456789012'
                        },
                        'name': 'OFICINA CENTRAL'
                    },
                    'role': 'FRONTOFFICE_ORDERS_ADMIN'
                }],
                'user': {'email': 'usuario.demo@example.com'},
                'permission': [
                    'USERS_PERMISSION',
                    'CURRENT_ACCOUNT_PERMISSION',
                ]
            },
            'errors': [],
        }
    }

    deliverySiteUserRoles() {
        return this.content().delivery_site_user_roles.map(deliverySiteUserRole => {
            return {
                'deliverySite': {
                    'address': deliverySiteUserRole.delivery_site.location.address,
                    'city': deliverySiteUserRole.delivery_site.location.city,
                    'code': deliverySiteUserRole.delivery_site.code,
                    'customer': {
                        'businessName': deliverySiteUserRole.delivery_site.customer.business_name,
                        'code': deliverySiteUserRole.delivery_site.customer.code,
                        'fantasyName': deliverySiteUserRole.delivery_site.customer.fantasy_name,
                        'taxpayerIdentificationNumber': deliverySiteUserRole.delivery_site.customer.taxpayer_identification_number
                    },
                    'name': deliverySiteUserRole.delivery_site.name
                },
                'role': deliverySiteUserRole.role
            }
        });
    }

    roles() {
        return this.content().delivery_site_user_roles.map(deliverySiteUserRole => {
            return deliverySiteUserRole.role
        });
    }

    customers() {
        return this.content().delivery_site_user_roles.map(deliverySiteUserRole => {
            return {
                'businessName': deliverySiteUserRole.delivery_site.customer.business_name,
                'code': deliverySiteUserRole.delivery_site.customer.code,
                'fantasyName': deliverySiteUserRole.delivery_site.customer.fantasy_name,
                'taxpayerIdentificationNumber': deliverySiteUserRole.delivery_site.customer.taxpayer_identification_number
            }
        })
    }

    permissions() {
        return this.content().permissions.map(permission => {
            return permission
        });
    }
}
